/* eslint-disable import/no-cycle */
import BusinessDetails from '../Components/pages/businessdetails/Container';
import MobileVerification from '../Components/pages/mobileverification/Container';
import MobileNumberSkipVerify from '../Components/pages/mobilenumberskipverify/Component';
import IdVerification from '../Components/pages/idverification/Container';
import CaptureDirector from '../Components/pages/personaldetails/Container';
import LocateYourTrust from '../Components/pages/locateyourtrust/Container';
import LocateYourTrustee from '../Components/pages/locateyourtrustee/Container';
import BankLink from '../Components/pages/banklink/Container';
import workflowUtils from '../utils/workflowUtils';
import identityUtils from '../utils/identityUtils';

/*
Route component definition:
* Template:
  [Rel]: { // the Rel is the value that we will receive from the api calls
    path: [], // used by React Router
    exact: true/false, // used by React Router
    component: Your component, // used by React Router
    label: The label of your component. The value that will be used to show the step label.
          If you don't specify this value, the Stepper will not be shown for that particular route.
    endHere: A flag to determine if the workflow should halt to an end.
    subStepOf: A string that indicates that this is a child step. This is use to consolidate multiple steps into a single step in the stepper
    props: Any additional props that you want to pass to the component
  }
*/

export const registrationRoutePrefix = '/registration';

export const routes = {
  BusinessDetails: {
    path: [registrationRoutePrefix, `${registrationRoutePrefix}/business`],
    exact: true,
    component: BusinessDetails,
    label: 'Business details',
  },
  Mobile: {
    path: [`${registrationRoutePrefix}/mobile`],
    component: MobileVerification,
    label: 'Mobile number',
  },
  MobileSkipVerify: {
    path: [`${registrationRoutePrefix}/mobile`],
    component: MobileNumberSkipVerify,
    label: 'Mobile number',
  },
  VerifyId: {
    path: [`${registrationRoutePrefix}/identification`],
    component: IdVerification,
    label: 'Personal details',
  },
  VerifyIdTrustee: {
    path: [`${registrationRoutePrefix}/trustee-identification`],
    component: IdVerification,
    label: 'Personal details',
  },
  CaptureDirector: {
    path: [`${registrationRoutePrefix}/lead`],
    component: CaptureDirector,
    label: 'Personal details',
    endHere: true,
  },
  TrustType: {
    path: [`${registrationRoutePrefix}/trust`],
    component: LocateYourTrust,
    label: 'Trust or Trustee details',
    subStepOf: 'BusinessDetails',
  },
  TrusteeType: {
    path: [`${registrationRoutePrefix}/trustee`],
    component: LocateYourTrustee,
    label: 'Trust or Trustee details',
    subStepOf: 'BusinessDetails',
  },
  BankLink: {
    path: ['/banklink'],
    component: BankLink,
    exact: true,
  },
  'BankLink/Pending': {
    path: ['/banklink'],
    component: BankLink,
    exact: true,
    props: { registrationStatus: 'Pending' },
  },
};

export const AlertRouteConfig = {
  VerifyIdSuccess: { path: `${registrationRoutePrefix}/identification/thank-you` },
  UploadIdSucess: { path: `${registrationRoutePrefix}/identification/upload-id/thank-you` },
  AdminSuccess: { path: `${registrationRoutePrefix}/identification/admin/thank-you` },
  TooManyAttempts: { path: `${registrationRoutePrefix}/identification/too-many-attempts` },
};

// this workflow is used for external customers
export const defaultWorkflow = [routes.BusinessDetails, routes.Mobile, routes.VerifyId];

export const relationshipManagerWorkflow = [
  routes.BusinessDetails,
  routes.Mobile,
  routes.VerifyId,
  routes.BankLink,
];

export const brokerRelationshipManagerWorkflow = [
  routes.BusinessDetails,
  routes.MobileSkipVerify,
  routes.VerifyId,
  routes.BankLink,
];

export const shiftTeamWorkflow = [
  routes.BusinessDetails,
  routes.MobileSkipVerify,
  routes.VerifyId,
  routes.BankLink,
];

export const trusteeWorkflow = [routes.BusinessDetails, routes.Mobile, routes.VerifyIdTrustee];

export const workflow = {
  processNextStep: (activeStepIndex, steps, nextStepLinks, activeMainStepIndex) =>
    workflowUtils.processNextStep(
      routes,
      activeStepIndex,
      steps,
      nextStepLinks,
      activeMainStepIndex,
    ),
  getWorkflowSteps: (hostname) => {
    const user = identityUtils.getCurrentUser();

    const {
      isCurrentUserBrokerRelationshipManager,
      isCurrentUserRelationshipManager,
      isCurrentUserInShiftTeam,
      hasInternalUserLoggedIn,
    } = identityUtils;

    const host = hostname || window.location.hostname;
    const { registrationMode } = workflowUtils.getRegistrationModeAndPortal(host);

    if (registrationMode !== 'rm' || !hasInternalUserLoggedIn()) {
      return defaultWorkflow;
    }

    if (isCurrentUserInShiftTeam(user)) {
      return shiftTeamWorkflow;
    }

    if (isCurrentUserBrokerRelationshipManager(user)) {
      return brokerRelationshipManagerWorkflow;
    }

    if (isCurrentUserRelationshipManager(user)) {
      return relationshipManagerWorkflow;
    }

    return defaultWorkflow;
  },
  getTrusteeWorkflowSteps: () => trusteeWorkflow,
};
